// extracted by mini-css-extract-plugin
export default {"add-customer-save-button-wrapper":"addCustomer_add-customer-save-button-wrapper__edh3K","customer-detail-label":"addCustomer_customer-detail-label__p2LQ0"};